import React from 'react';
import { Link } from 'react-router-dom';
import { X, Radio } from 'lucide-react';

export const MobileMenu = ({ 
  navLinks, 
  isActive, 
  radioSettings, 
  onClose, 
  openRadio 
}) => {
  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999,
        backgroundColor: '#000',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      {/* Gradient overlay */}
      <div 
        style={{
          position: 'absolute',
          top: 0, left: 0, right: 0, bottom: 0,
          background: 'radial-gradient(circle at 50% 0%, rgba(249,115,22,0.2) 0%, transparent 50%), radial-gradient(circle at 0% 100%, rgba(34,197,94,0.15) 0%, transparent 50%)',
          pointerEvents: 'none'
        }}
      />

      {/* Close button */}
      <button
        onClick={onClose}
        data-testid="mobile-menu-close-btn"
        style={{
          position: 'absolute',
          top: 20, right: 20, zIndex: 10,
          width: 48, height: 48,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          borderRadius: '50%',
          background: 'linear-gradient(to right, rgba(249,115,22,0.2), rgba(34,197,94,0.2))',
          border: '1px solid rgba(249,115,22,0.5)',
          color: '#fff'
        }}
      >
        <X style={{ width: 24, height: 24 }} />
      </button>

      {/* Menu Content */}
      <div 
        style={{
          position: 'absolute',
          top: 100, left: 24, right: 24, bottom: 40,
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          zIndex: 50
        }}
      >
        {/* Logo */}
        <div style={{ marginBottom: 40, textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <img src="/sun-logo.png" alt="DharmaR" style={{ width: 56, height: 56, objectFit: 'contain', marginBottom: 12 }} />
          <div style={{ 
            fontSize: 32, fontWeight: 'bold', 
            background: 'linear-gradient(to right, #f97316, #22c55e)',
            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text'
          }}>
            DharmaR
          </div>
        </div>

        {/* Navigation Links */}
        <nav style={{ display: 'flex', flexDirection: 'column', gap: 12, width: '100%', maxWidth: 300 }}>
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              onClick={onClose}
              style={{
                width: '100%', textAlign: 'center',
                padding: '16px 24px', borderRadius: 16,
                fontSize: 18, fontWeight: 600, textDecoration: 'none',
                transition: 'all 0.3s',
                background: isActive(link.path) 
                  ? 'linear-gradient(to right, #f97316, #22c55e)' 
                  : 'rgba(255,255,255,0.05)',
                color: isActive(link.path) ? '#fff' : '#d1d5db',
                border: isActive(link.path) ? 'none' : '1px solid rgba(255,255,255,0.1)',
                boxShadow: isActive(link.path) ? '0 10px 30px rgba(249,115,22,0.3)' : 'none'
              }}
            >
              {link.name}
            </Link>
          ))}
        </nav>

        {/* Radio Button */}
        {radioSettings?.is_active && (
          <button
            onClick={() => {
              onClose();
              setTimeout(openRadio, 300);
            }}
            data-testid="mobile-radio-btn"
            style={{
              marginTop: 32, position: 'relative',
              borderRadius: 9999, overflow: 'hidden',
              border: 'none', cursor: 'pointer'
            }}
          >
            <div style={{ 
              position: 'absolute', inset: 0, 
              background: 'linear-gradient(to right, #f97316, #eab308, #22c55e)',
              backgroundSize: '200% 200%',
              animation: 'gradient-x 3s ease infinite'
            }} />
            <div style={{ 
              position: 'absolute', top: 2, left: 2, right: 2, bottom: 2, 
              borderRadius: 9999, background: '#000' 
            }} />
            <div style={{ 
              position: 'relative', display: 'flex', alignItems: 'center', gap: 12, 
              padding: '16px 32px', color: '#fff', fontWeight: 600
            }}>
              <Radio style={{ width: 20, height: 20, color: '#f97316' }} />
              <span>Listen Live</span>
              <span style={{
                width: 8, height: 8, backgroundColor: '#22c55e',
                borderRadius: '50%',
                animation: 'ping 1s cubic-bezier(0, 0, 0.2, 1) infinite'
              }} />
            </div>
          </button>
        )}
      </div>

      {/* Floating particles */}
      <div style={{ position: 'absolute', inset: 0, overflow: 'hidden', pointerEvents: 'none' }}>
        {[...Array(6)].map((_, i) => (
          <div
            key={`particle-${i}`}
            style={{
              position: 'absolute', width: 8, height: 8,
              borderRadius: '50%', opacity: 0.4,
              background: i % 2 === 0 ? '#f97316' : '#22c55e',
              left: `${15 + i * 15}%`,
              top: `${20 + (i % 3) * 25}%`,
              animation: `float ${3 + i * 0.5}s ease-in-out infinite`,
            }}
          />
        ))}
      </div>
    </div>
  );
};
